/** 用户token */
export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN'

/** 主题色 */
export const THEME_KEY = 'THEME__'

/** 用户信息 */
export const USER_INFO_KEY = 'USER__INFO__'

// role info key
export const ROLES_KEY = 'ROLES__KEY__'

/** 标签页 */
export const TABS_ROUTES = 'TABS_ROUTES'

// 用户首次访问链接
export const USER_FIRST_VISISIT_LINK = 'USER_FIRST_VISISIT_LINK'

// 用户登入失败次数
export const USER_LOGIN_FAIL_COUNT = 'USER_LOGIN_FAIL_COUNT'

// 分享人 token
export const SHARE_TOKEN_KEY = 'share_token'

// 浏览时长
export const BROWSE_TIME = 'BROWSE_TIME'

// 上一次浏览记录时间戳
export const LAST_BROWSE_TIME = 'LAST_BROWSE_TIME'

// 资讯分享次数
export const ARTICLE_SHARE_COUNT = 'ARTICLE_SHARE'

// 鉴权Key
export const AUTH_KEY = 'AUTH_KEY'

// IOS微信入口链接
export const IOS_WX_ENTRY_URL = 'IOS_WX_ENTRY_URL'
